import { ReactElement } from 'react';
import { AddressFields, SingleDatePicker, TextInput } from '@components/common';
import { StaticDetailsCommonFormSectionProps } from '.';
import { keyDownEvent } from '@helper/utils';

export const FormSection = (props: StaticDetailsCommonFormSectionProps): ReactElement => {
	const { formik, isEditing, getBasicFormData, formId } = props;

	return (
		<>
			<li className="form-control d-col d-col-2">
				<TextInput
					id="primary_number"
					name="primary_number"
					type="text"
					onBlur={formik.handleBlur}
					value={formik.values.primary_number ?? ''}
					setFieldValue={formik.setFieldValue}
					label="Primary Mobile No"
					error={formik.touched.primary_number && formik.errors.primary_number ? formik.errors.primary_number : null}
					onKeyDown={keyDownEvent}
					disabled={isEditing || !!(formId && getBasicFormData?.phone)}
					maxLength={10}
					required
				/>
			</li>
			<li className="d-col d-col-2">
				<SingleDatePicker
					className="single-date-picker"
					id="birth_date"
					name="birth_date"
					value={formik.values.birth_date}
					label="Date of Birth"
					formik={formik}
					disabled={isEditing}
					required
					error={formik.errors.birth_date ? formik.errors.birth_date : null}
				/>
			</li>
			<li className="d-col d-col-2">
				<SingleDatePicker
					className="single-date-picker"
					id="wedding_anniversary"
					name="wedding_anniversary"
					value={formik.values.wedding_anniversary}
					label="Wedding Anniversary"
					formik={formik}
					disabled={formik.values.unmarried_chekbox || isEditing}
					maxDate={new Date()}
					error={
						formik.touched.wedding_anniversary && formik.errors.wedding_anniversary
							? formik.errors.wedding_anniversary
							: null
					}
				/>
			</li>
			<AddressFields
				mainFieldName="permanent"
				formik={formik}
				townName="permanent_town"
				addressName="permanent_address"
				zipcodeName="permanent_zipcode"
				cityName="permanent_city"
				streetName="permanent_street"
				stateName="permanent_state"
				addressLabel="Current Address"
				isEditing={isEditing}
			/>
			<li className="form-control d-col d-col-2">
				<TextInput
					id="samaj"
					name="samaj"
					type="text"
					onBlur={formik.handleBlur}
					value={formik.values.samaj ?? ''}
					setFieldValue={formik.setFieldValue}
					label="Samaj"
					disabled={formik.values.samaj_checkbox || isEditing}
					error={formik.touched.samaj && formik.errors.samaj ? formik.errors.samaj : null}
				/>
			</li>
		</>
	);
};
